module.exports = __webpack_public_path__ + "img/制御工学3_1_3.a18ebc3a.png";